/*
 * @Description: 权限检测判断注入app
 * @Author: 琢磨先生
 * @Date: 2022-12-16 10:50:01
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2023-03-22 10:40:09
 */

const install = (app) => {
  /**
   * 通过api地址（url）判断是否拥有请求的权限
   */
  app.config.globalProperties.$power = (url) => {
    var apis = [];
    var json = localStorage.getItem(
      app.config.globalProperties.$cfg.API_STORE_KEY
    );
    if (json) {
      apis = JSON.parse(json);
    }
    console.log(url);
    return true;
    // return apis.findIndex((o) => o.toLowerCase() == url.toLowerCase()) > -1;
  };
};

export default { install };
